import {
  ChatAPI,
  getCurrentChat,
  setChatLoading,
  setCurrentChatSession,
} from '@guuru/chat-web';
import events from '@guuru/events-web';

const chatStart = {
  validate() {
    const { chatId } = getCurrentChat();
    return !chatId;
  },

  async render(partnerId) {
    setCurrentChatSession({ chatId: null, messages: [] });

    ChatAPI.storeAutomationBehavior(partnerId, null);
    ChatAPI.storeResetPendingMessages();

    const { isChatAvailable } = await ChatAPI.getChatSettings(partnerId);
    const channel = ChatAPI.storeRetrieveChannel();
    if (channel === 'chat') {
      if (!isChatAvailable) {
        setCurrentChatSession({
          messages: [
            ChatAPI.messages.createBotMessage(
              Date.now(),
              'chat:::outOfWorkingHours',
              'message',
              {},
              false,
              false,
            ),
          ],
        });
        setChatLoading(false);
        return { stayInCurrentStep: true };
      }
    }

    events.startingNew();
    return { goToNextStep: true };
  },
};

export default chatStart;
